import {
    formatDate,
    ListProviderTransactionsRequest,
    RefundStatusType,
    Transaction,
    TransactionStatusType,
} from '@enter/core';
import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { IItemDetail, IItemListing } from './root.store';
import { waitForNoReason } from './util';
import { generateAmount, generateItemListing, oneOf } from './util.generator';

export class TransactionGenerator {
    public transactions: Transaction[] = [];

    // TODO: extract index/storeTo/loadFrom as utility class
    public index: Map<string, Map<string, string[]>> = new Map<string, Map<string, string[]>>();

    constructor() {
        this.generateEntities(7);
    }

    public async loadTransactionListing(
        lptr: ListProviderTransactionsRequest,
    ): Promise<IItemListing<Transaction> | undefined> {
        await waitForNoReason(400);
        return generateItemListing(lptr, this.transactions);
    }
    public async loadTransaction(id: string): Promise<Transaction | undefined> {
        let transaction = _.find(this.transactions, { id });
        if (!transaction) {
            transaction = this.generateTransaction(id);
        }
        return transaction;
    }
    public async loadTransactionDetail(id: string): Promise<IItemDetail<Transaction> | undefined> {
        return undefined;
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateTransaction());
    }

    private generateTransaction(id: string = faker.string.uuid()): Transaction {
        const transaction = {
            id,
            created: formatDate('Date')(faker.date.past()),
            invoiceId: _.uniqueId('invoice'),
            amount: generateAmount(),
            from: {
                userId: _.uniqueId('from'),
                legacyUserId: _.uniqueId('from'),
            },
            to: {
                userId: _.uniqueId('to'),
                legacyUserId: _.uniqueId('to'),
            },
            billedByDescriptor: faker.lorem.words(),
            chargedBankingId: _.uniqueId('chargedBanking'),
            subscriptionId: _.uniqueId('subscription'),
            memo: faker.lorem.sentence(),
            status: oneOf(TransactionStatusType),
            refund: _.sample([
                undefined,
                {
                    amount: generateAmount(),
                    reimburseAmount: generateAmount(),
                    memo: faker.lorem.sentence(),
                    status: oneOf(RefundStatusType),
                },
            ]),
        };
        this.transactions.push(transaction);
        return transaction;
    }

    private storeToIndex<T>(model: string, key: string, values: T | T[]): void {
        if (!this.index.has(model)) {
            this.index.set(model, new Map<string, string[]>());
        }
        const array = _.get(this, model);
        const index = this.index.get(model);
        if (array && index) {
            const items = _.concat([], values);
            const oldIds = index.get(key) || [];
            const newIds = _.map(items, 'id');
            index.set(key, [...oldIds, ...newIds]);
            items.forEach(item => array.indexOf(item) === -1 && array.push(item));
        }
    }

    private loadFromIndex<T>(model: string, key: string): T[] | undefined {
        const array = _.get(this, model);
        const index = this.index.get(model);
        if (array && index) {
            const ids = index.get(key);
            return _.filter(array, (item: T): boolean => _.includes(ids, _.get(item, 'id')));
        }
    }
}
